var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 13.05L10.93 8.28L16.1 3.49C16.41 3.2 16.59 2.82 16.59 2.41C16.59 2 16.42 1.62 16.1 1.33C15.46 0.739997 14.3 0.739997 13.66 1.33L8.54999 6.06L3.45999 1.35C2.81999 0.759997 1.64999 0.759997 1.01999 1.35C0.709989 1.64 0.529999 2.02 0.529999 2.43C0.529999 2.84 0.699989 3.22 1.01999 3.51L6.17001 8.28L1.04999 13.03C0.739988 13.32 0.559998 13.7 0.559998 14.11C0.559998 14.52 0.729988 14.9 1.04999 15.19C1.68999 15.78 2.84999 15.78 3.48999 15.19L8.56 10.5L13.65 15.21C13.81 15.36 14 15.48 14.21 15.56C14.43 15.64 14.69 15.68 14.88 15.68C15.11 15.68 15.34 15.64 15.55 15.55C15.76 15.47 15.95 15.35 16.11 15.2C16.27 15.05 16.39 14.89 16.47 14.7C16.55 14.52 16.59 14.32 16.59 14.13C16.59 13.93 16.55 13.74 16.46 13.56C16.36 13.36 16.24 13.19 16.08 13.05Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f17b2b316a3b268ec7dab8e732a2c31d.svg";
export { ForwardRef as ReactComponent };